export const bannerBgColor = "#ffffff";
export const tabMenuColor = "#E9EFF4";
export const sidebarColor = "#ffffff";
export const tabMenuActionColor = "#3B4752";
export const titleBanner = "";
export const logoWeb = "assets/images/logo-asp.png";
export const textColor = "#3B4752";
export const textColorActive = "#3B4752";
